import React from 'react'
import PropTypes from 'prop-types'
import SearchBarItem from './../../../containers/SearchBarContainer'
import SearchMobileItem from './../../../containers/SearchMobileContainer'
import { Link } from 'react-router'
import { Helmet } from 'react-helmet'
import Slider from 'react-slick/lib/index'

class HomeIndex extends React.Component {
  static propTypes = {
    homeContent: PropTypes.array,
    fetchPostsWithReduxHome: PropTypes.func,
  }

  componentDidMount () {
    this.props.fetchPostsWithReduxHome()
  }

  render () {
    const configBanners = [
      'https://s3.ap-south-1.amazonaws.com/khovtt/viet-trung-thong-web-banner-nha-may-dien.jpeg',
      'https://s3.ap-south-1.amazonaws.com/khovtt/viet-trung-thong-web-banner-nang-luong.jpeg',
      'https://s3.ap-south-1.amazonaws.com/khovtt/viet-trung-thong-web-banner-dien-cao-the.jpeg',
      'https://s3.ap-south-1.amazonaws.com/khovtt/viet-trung-thong-web-banner-song-am.jpeg',
    ]
    const widthFull = {
      width: '1423px'
    }
    const tCenter = {
      textAlign: 'center'
    }

    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000
    }
    return (
      <div>
        <Helmet>
          <script type='text/javascript'>
            {`
    function initMap() {
        //
    }

            `}
          </script>
        </Helmet>
        <SearchBarItem valueInit={this.props.params.splat} />
        <SearchMobileItem valueInit={this.props.params.splat} />

        <div className='header-media'>
          <div id='banner-module' className='houzez-module banner-module'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-sm-12 no-padding'>
                  <Slider style={widthFull} {...settings}>
                    {configBanners.map((banner, bkey) => {
                      return (
                        <div key={bkey} className='item' style={tCenter}>
                          <img src={banner}
                            width='100%' height='603' alt='Hình ảnh Banner' />
                        </div>
                      )
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section id='section-body'>
          <div className='houzez-module module-title text-center'>
            <div className='container'>
              <div className='row'>
                <div className='col-sm-12 col-xs-12'>
                  <h2>Sản Phẩm</h2>
                  <h3 className='sub-heading'>Danh sách mới cập nhật</h3>
                </div>
              </div>
            </div>
          </div>
          <div id='agents-module' className='houzez-module agents-module'>
            <div className='container'>
              <div className='agents-blocks-main'>
                <div className='row no-margin'>
                  {this.props.homeContent && this.props.homeContent.map((product, pkey) => {
                    return (
                      <div key={pkey} className='col-md-3 col-sm-6 col-xs-12'>
                        <div className='agents-block'>
                          <figure className='auther-thumb'>
                            <img src={product.img} alt={'thumb' + product.name}
                              width='71' height='71' className='img-circle img-thumbnail' />
                          </figure>
                          <div className='text-center'>
                            {product.name}
                          </div>
                          <div className='block-body'>
                            <p className='auther-info'>
                              <span className='blue'><Link to={product.urlfactory}>{product.factory}</Link></span>
                              <span><Link to={product.urltypeproduct}>{product.typeproduct}</Link></span>
                            </p>
                            <p className='description'>{product.descriptshort}
                            </p>
                            <Link to={product.urlDetail}>Chi tiết</Link>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default HomeIndex



// WEBPACK FOOTER //
// ./src/routes/HomeIndex/components/HomeIndex.js